import { useMemo, useState } from 'react';
import { SelectedMultiOption } from '@weareopenr/component-library/build/components/MultiSelect/utilities';
import { getChannelLabel, getPricingChannels } from 'src/helpers/channels/getPricingChannels';
import { IPriceBandWithVenues } from 'src/types/priceBand.types';
import { IAggregator } from 'src/types/aggregator.types';

export const DEFAULT_PRICE_BAND_FILTER_ID = '__default_price_band__';

export const usePriceBandExternalSystemFilter = (
  priceBands: IPriceBandWithVenues[],
  externalSystems: IAggregator[],
) => {
  const [selectedViewIds, setSelectedViewIds] = useState<string[]>([]);

  const viewFilterOptions: SelectedMultiOption[] = useMemo(() => {
    const priceBandChildren: SelectedMultiOption[] = priceBands.map((pb, idx) => ({
      id: pb.priceBandId ?? DEFAULT_PRICE_BAND_FILTER_ID,
      label: pb.name,
      display_order: idx,
      children: [],
    }));

    // Channel rows are keyed on extension instance, so the filter ids must match them, not aggregatorId.
    const channelChildren: SelectedMultiOption[] = getPricingChannels(externalSystems).map((channel, idx) => ({
      id: channel.extensionInstanceId,
      label: getChannelLabel(channel),
      display_order: idx,
      children: [],
    }));

    const groups: SelectedMultiOption[] = [];

    if (priceBandChildren.length > 0) {
      groups.push({ id: '__price_bands_group__', label: 'Price Bands', display_order: 0, children: priceBandChildren });
    }
    if (channelChildren.length > 0) {
      groups.push({ id: '__channels_group__', label: 'Channels', display_order: 1, children: channelChildren });
    }

    return groups;
  }, [priceBands, externalSystems]);

  return {
    selectedViewIds,
    setSelectedViewIds,
    viewFilterOptions,
  };
};
